export function validateAllNumber(str) {
    const reg = /^\d{1,11}$/
    return reg.test(str)
}